module.exports = __webpack_public_path__ + "static/media/01.b085ad4c.png";